import { z } from 'zod'

import { ZReceiptInformation, ZAccount } from '@/entities/user/@x/auth'

export enum JoinType {
  GUEST = 'guest',
  HOST = 'host',
}

export const ZSignUp = z.object({
  email: z.string(),
  password: z.string(),
  name: z.string(),
  certNum: z.string().optional(),
  marketingAgree: z.boolean().optional(),
  profileImageUrl: z.string().optional(),
  passportImageUrl: z.string().optional(),
  phoneNumber: z.string().optional(),
  hostIntro: z.string().optional(),
  recommenderPhoneNumber: z.string().optional(),
  ...ZAccount.partial().shape,
  ...ZReceiptInformation.partial().shape,
})

export const ZSignUpRequest = z.object({
  joinType: z.nativeEnum(JoinType),
  body: ZSignUp,
})

export const ZSignUpAirbridgeData = z.object({
  action: z.string(),
  event_name: z.string(),
  value: z.number(),
  label: z.string(),
})

export const ZSignUpResponse = z.object({
  accessToken: z.string(),
  refreshToken: z.string(),
  firebaseToken: z.string(),
  airbridgeData: ZSignUpAirbridgeData,
})

export type TSignUp = z.infer<typeof ZSignUp>
export type TSignUpRequest = z.infer<typeof ZSignUpRequest>
export type TSignUpResponse = z.infer<typeof ZSignUpResponse>
export type TSignUpEvent = z.infer<typeof ZSignUpAirbridgeData>
